import { ViewIcon, EditIcon } from '@chakra-ui/icons';

export const columnsDataVehicles = [
  {
    Header: "Matrícula",
    accessor: "plate",
  },
  {
    Header: "Chasis",
    accessor: "chassisNumber",
  },
  {
    Header: "Motor",
    accessor: "engineNumber",
  },
  {
    Header: "Marca",
    accessor: "model.brand.name",
  },
  {
    Header: "Modelo",
    accessor: "model.description",
  },
  {
    Header: "Contacto",
    accessor: "representative",
    cell: (info) => {
      const representative = info.getValue();
      return representative || '-';
    }
  },
  {
    Header: "Teléfono Contacto",
    accessor: "representativeContact",
    cell: (info) => {
      const contact = info.getValue();
      return contact || '-';
    }
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
      {
        label: 'Ver',
        icon: <ViewIcon />,
        colorScheme: 'blue',
        type: 'view'
      }
    ]
  }
];
